<template style="height: 100%;">
    <div style="height: 100%;display: flex" id="homeBox">
        <el-row class="video-tree flex"  style="display: flex;width: 100%">
            <el-col :span="treespan"  v-show="showTree" :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <left-tree @showData="showData"></left-tree>
            </el-col>
            <el-col :span="rightspan"  style="height: 100%;min-width: 320px;width: 100%">
                <div  style="display: flex;align-items: center">
                     <div class="df">
                       <div style="display: flex;align-items: center">
                            <el-button style="font-size: 1.571rem;height: 2.857rem" type="text"  @click="closeTree" v-show="isright" icon="el-icon-s-fold"></el-button>
                            <el-button style="font-size: 1.571rem;height: 2.857rem" type="text" @click="openTree" v-show="!isright" icon="el-icon-s-unfold"></el-button>
                            <el-date-picker
                                    style="width: 150px;flex:1"
                                    @input="dateSearch"
                                    value-format="yyyy"
                                    format="yyyy"
                                    size="mini"
                                    v-model="dateMonth"
                                    type="year"
                                    placeholder="选择年"
                            >
                            </el-date-picker>
<!--                            <el-select @change="kqdataChange" style="width: 150px;margin-left: 20px;flex:1" size="mini" v-model="kqdata" slot="prepend" placeholder="请选择">-->
<!--                                <el-option v-for="val in kaoqinList" :key="val.i_id" :label='val.vc_tcname' :value="val.vc_tcname"></el-option>-->
<!--                            </el-select>-->
                            <el-input
                                    style="width: 150px;margin-left: 20px;flex:1"
                                    @input="peopleSearch"
                                    size="mini"
                                    class="input"
                                    placeholder="请输入人员"
                                    v-model="vc_search"
                                    clearable>
                            </el-input>
                        </div>
                        <el-button type="text" style="" icon="el-icon-document"  @click="addFun">一键生成年假</el-button>
                    </div>
                </div>
                <el-table
                        size="mini"
                        ref="table"
                        :height="tableHeight"
                        highlight-current-row
                        :data="tableData"
                        border>
<!--                    <el-table-column-->

<!--                            prop="code"-->
<!--                            label="编号"-->
<!--                            show-overflow-tooltip>-->
<!--                    </el-table-column>-->
                    <el-table-column

                            prop="vc_uname"
                            label="姓名"
                            show-overflow-tooltip>
                        <!--<template  slot-scope="scope">
                            {{scope.row.vc_name+' '}}{{scope.row.departmentName}}
                        </template>-->
                    </el-table-column>
                    <el-table-column
                            prop="f_days"
                            label="年假天数"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="!scope.row.edit">{{scope.row.f_days}}</span>
                            <el-input-number style="width: 100%" size="mini" :controls="false" v-else v-model="scope.row.f_days"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="100px"
                            prop="f_usedays"
                            label="年假已用天数"
                            show-overflow-tooltip>

                    </el-table-column>
                    <el-table-column
                            prop="dt_usestarttime"
                            label="年假开始日期"

                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-date-picker
                                    style="width:100%;"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    size="mini"
                                    v-model="scope.row.dt_usestarttime"
                                    type="date"
                                    placeholder="年假开始日期"
                                    v-if="scope.row.edit"
                            >
                            </el-date-picker>
                            <span v-else>{{scope.row.dt_usestarttime}}</span>
                        </template>

                    </el-table-column>
                    <el-table-column
                            prop="dt_useendtime"
                            label="年假结束日期"

                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="i_usemonth"
                            label="周期(月)"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input-number style="width: 100%"size="mini" :controls="false" v-if="scope.row.edit" v-model="scope.row.i_usemonth"></el-input-number>
                            <span v-else>{{scope.row.i_usemonth}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="85"
                            prop="vc_lruname"
                            label="录入人"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="65"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button style="color:red;"  v-if="!scope.row.edit&&!edit" type="text" size="mini" @click="editFun(scope.row,scope.row.edit)">编辑</el-button>

                            <el-button style="color:red;"  v-if="scope.row.edit&&edit" type="text" size="mini" @click="saveFun(scope.row)">{{$t('button_save')}}</el-button>
                            <el-button style="color:red;"  v-if="scope.row.edit&&edit" type="text" size="mini" @click="cancelFun(scope.row)">取消</el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <div class="pages">
                        <div class="choosepage flexother mrt20 fl">
                            <el-pagination
                                    small

                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="this.currentPage"
                                    :page-sizes="[10, 20, 30, 40]"
                                    :page-size="this.pageSize"
                                    layout="total,sizes"
                                    :total="this.total"
                            >
                            </el-pagination>
                            <el-pagination
                                    small
                                    :pager-count="5"
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="this.currentPage"
                                    :page-size="this.pageSize"
                                    layout="prev, pager, next, jumper"
                                    :total="this.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import LeftTree from "./LeftTree";
    export default {
        name: "workManage",
        components:{
            LeftTree,
        },
        data(){
            return{
                activePage:"report/res/spread.vue",
                treeuserid:0,
                kaoqinList:[],
                kaoqini_id:0,
                startDate:'',
                endDate:'',
                kqdata:'',
                showTree:true,//显示树
                isright:true,//树显示按钮
                bianjiData:{},//编辑数据
                LeaveEntry:false,//显示弹框
                tableData: [],//列表数据
                currentPage:1,//页
                pageSize:10,//条
                total:0,//总数
                baseerp:'',//公共样式
                dateMonth:'',//月搜索
                vc_search:'',//人员搜索数据
                tableHeight:0,//列表高度
                cancellationid:0,//作废传入id
                title:'',//弹框标题
                jbdata:[],
                treedata:[],
                id:0,
                type:0,
                leaveData:{},

                qjtitle:'',
                leaveper:{},
                dateList:'',
                LeaveinEntry:false,
                socket:null,
                treespan:4,
                rightspan:20,
                edit:false,
            }
        },
        activated(){
            this.onResize();
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },




        },

        mounted(){
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();

            })

            // let month=(new Date().getMonth()+1)>10?new Date().getMonth()+1:'0'+(new Date().getMonth()+1)
            this.dateMonth=new Date().getFullYear().toString()
            //获取假勤列表
        },
        methods:{

            getRowClassName({row, rowIndex}) {//有children就显示箭头
                if (row.hasChildren==false) {
                    return 'row-expand-cover';
                }
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },
            ...mapActions(["getCurrentMenuId"]),
           closeIn(){
                // console.log('closeIn')
                this.LeaveinEntry = false
                this.getKqList()
                // this.$refs.newCalender.btnup()
            },
            showData(val,kaoqini_id){
                // console.log(val,123)
                this.edit=false

                this.treedata = val
                this.kaoqini_id=kaoqini_id
                if(val==''){
                    this.tableData=[]
                    this.total=0
                }else{
                    this.annualLeaveList()
                }

            },
            //搜索人员查询
            peopleSearch(val){
                this.currentPage=1
                this.vc_search=val
                this.annualLeaveList()
            },

            //关闭树
            closeTree(){
                this.isright=false
                this.showTree=false
                this.$refs.right.style='width:100%'
            },
            //显示树
            openTree(){
                this.isright=true
                this.showTree=true
                this.$refs.right.style='width:87%'

            },

            //搜索框月份搜索
            dateSearch(val){
                this.currentPage=1
                this.dateMonth=val
                // console.log(val)
                this.annualLeaveList()
            //
            //
            },
            editFun(row,edit){
                row.edit=!edit
                this.edit=true
            },
            addFun(){
                this.$confirm('是否生成年假', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.resetAnnualLeave();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            saveFun(row){
                    this.$confirm('是否保存该项', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        this.saveAnnualLeave(row);
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        })
                        this.edit=false
                        row.edit=false
                    })
            },
            cancelFun(row){
                this.edit=false
                row.edit=false
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.annualLeaveList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.annualLeaveList()
            },

            //分页获取请假加班出差数据
            async annualLeaveList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    pageSize:this.pageSize,
                    currentPage: this.currentPage,
                    vc_foryear:this.dateMonth,
                    // date:'',
                    i_gid:this.treedata.type=='depart'?this.treedata.value:null,
                    // userId:this.treeuserid
                    userId:this.treedata.type=='person'?this.treedata.value:null,
                    vc_search:this.vc_search,

                }
                let res = await API.annualLeaveList(params);
                if (res.code == 1) {
                    this.tableData=res.data.list
                        this.total=res.data.total
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async resetAnnualLeave(){
                let params = {
                    i_kqtcid:this.kaoqini_id,
                    vc_foryear:this.dateMonth,
                }
                let res = await API.resetAnnualLeave(params);
                if (res.code == 1) {

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async saveAnnualLeave(row){
                let params = row
                let res = await API.saveAnnualLeave(params);
                if (res.code == 1) {
                    this.$message.success(res.message);

                    this.currentPage=1
                    this.annualLeaveList()
                    this.edit=false
                    row.edit=false
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .row-expand-cover .el-table__expand-icon {
        visibility: hidden;
    }
    .df{
        /*min-width: 39.286rem;*/
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
/deep/{
    .row-expand-cover .el-table__expand-icon {
        visibility: hidden;
    }
    .el-table--enable-row-transition{
        /*min-width: 64.286rem !important;*/
    }
    .el-button--text{
        padding: 0 !important;
        margin-left: 0 !important;
        margin-right: 10px;
    }
    .el-tabs__content{
        /*height: 90% !important;*/
        overflow: visible !important;
        height:calc(100% - 0.357rem) !important;
    }
}
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
.input{
    width: 14.286rem;
}
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }

    /deep/{
        .el-dialog{
            min-width: 900px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table__expanded-cell[class*=cell]{
            padding: 5px;
        }
        .dtj{
            color: #409EFF;
        }
        .tg{
            color: #03cb45;
        }
        .spz{
            color: #ffbe06;
        }
        .wtg{
            color: #ff0500;
        }
        .yzf{
            color: #878787;
        }
    }

</style>